module.exports = __webpack_public_path__ + "static/media/emptyState.4c800c2a.svg";